import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { useState, useEffect } from 'react';
import LayoutWithSidebar from '../components/common/layoutWithSidebar';
import { HeaderContainer } from '../components/dashboard/AgentInfoHeader';
import ReservationManagementTabs from '../components/Reservation-Management/ReservationManagementTabs';
import { useStores } from '../components/UserJourny/FirstUserJourney/useStores';
import theme from '../theme';

const ReservationManagement = () => {
  const { storesList, storesListLoading } = useStores();
  const [selectedStore, setSelectedStore] = useState<any>(null);

  useEffect(() => {
    if (storesList?.length > 0 && !selectedStore) {
      setSelectedStore(storesList[0]);
    }
  }, [storesList, selectedStore]);

  useEffect(() => {
    if (selectedStore && storesList?.length > 0) {
      const updatedStore = storesList.find(
        (store: any) => store.id === selectedStore.id
      );
      if (updatedStore) {
        setSelectedStore(updatedStore);
      }
    }
  }, [storesList, selectedStore]);

  const handleStoreChange = (event: SelectChangeEvent) => {
    const store = storesList?.find(
      (store: any) => store.friendly_name === event.target.value
    );
    setSelectedStore(store);
  };

  return (
    <LayoutWithSidebar margin={2}>
      <HeaderContainer>
        <Typography
          sx={{
            fontFamily: 'DM Sans',
            fontWeight: 600,
            fontSize: '24px',
            lineHeight: '100%',
            letterSpacing: '-0.01em',
            color: '#2B2D3F',
          }}
        >
          Reservation Managment
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Typography fontSize={12} fontWeight={400} color="text.secondary">
              Select Store:
            </Typography>
            <Select
              sx={{
                width: 'fit-content',
                height: 34,
                '& .MuiSelect-select': {
                  display: 'flex',
                  padding: '4px 14px',
                  alignItems: 'center',
                  borderRadius: '6px',
                  border: '1px solid #DCE0E7',
                  background: '#F8F9FC',
                  fontWeight: 400,
                  lineHeight: 'normal',
                  letterSpacing: '-0.14px',
                  color: theme.palette.lightGray.text,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              }}
              value={selectedStore?.friendly_name || ''}
              onChange={handleStoreChange}
              displayEmpty
            >
              {storesList?.map((store: any) => (
                <MenuItem key={store.id} value={store?.friendly_name}>
                  {store.friendly_name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
      </HeaderContainer>
      <Box sx={{ height: 'calc(100vh - 120px)' }}>
        <ReservationManagementTabs
          selectedStore={selectedStore}
          isStoresLoading={storesListLoading}
        />
      </Box>
    </LayoutWithSidebar>
  );
};

export default ReservationManagement;
